import { Outlet } from "react-router-dom";
import Navbar from "@/components/site/NavbarMega";
import Footer from "@/components/site/FooterV2";
import { WhatsAppFloat, MobileCTA, FloatingBookCTA } from "@/components/site/Widgets";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] pb-14 lg:pb-0">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <FloatingBookCTA />
      <MobileCTA />
    </div>
  );
}
